<template>
  <v-layout justify-center>
    <v-flex md8 xs12>
      <v-layout row wrap>
        <v-flex md12>
          <blockquote class="blockquote" v-if="event.messages.length === 0">
            {{
              $t('components.eventTabVotersAndCommunication.communicationEmpty')
            }}
          </blockquote>
          <div v-else>
            <v-tabs>
              <v-tab>{{
                $t('components.eventTabVotersAndCommunication.live')
              }}</v-tab>
              <v-tab>{{
                $t('components.eventTabVotersAndCommunication.archive')
              }}</v-tab>
              <v-tab-item>
                <MessageList
                  :messages="liveMessages"
                  v-on:message-delete="handleMessageDelete"
                  v-on:message-to-archive="handleMessageToArchive"
                  v-on:message-from-archive="handleMessageFromArchive"
                ></MessageList>
              </v-tab-item>
              <v-tab-item>
                <MessageList
                  :messages="archivedMessages"
                  v-on:message-delete="handleMessageDelete"
                  v-on:message-to-archive="handleMessageToArchive"
                  v-on:message-from-archive="handleMessageFromArchive"
                ></MessageList>
              </v-tab-item>
            </v-tabs>
          </div>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import Message from '@/models/Message.js'
import MessageList from '@/components/MessageList.vue'
import handle_session_error from '@/helpers/handle_session_error.js'

function getIndexById(id, array, callback) {
  let found = false

  for (let index = 0; index < array.length; index++) {
    if (array[index].id === id) {
      found = true
      callback(index)
      break
    }
  }

  return found
}

export default {
  components: {
    MessageList,
  },

  props: ['event'],

  computed: {
    // Sorts messages from latest to oldest.
    sortedMessages: function () {
      return [...this.event.messages].sort((a, b) => {
        return a.created_at > b.created_at
          ? -1
          : a.created_at < b.created_at
          ? 1
          : 0
      })
    },

    liveMessages: function () {
      return this.sortedMessages.filter(message => {
        return !message.archived
      })
    },

    archivedMessages: function () {
      return this.sortedMessages.filter(message => {
        return message.archived
      })
    },

    unseenMessages: function () {
      return [...this.event.messages].filter(message => {
        return !message.seen
      })
    },
  },

  destroyed: function () {
    this.$store.state.pusherInstance.unsubscribe(
      `private-encrypted-event_${this.event.id}_messages`
    )
  },

  created: function () {
    // Don't bind to channel if there is no event.
    if (
      this.event.id === null ||
      this.event.id === 0 ||
      this.event.status !== 'active'
    ) {
      return
    }

    this.$emit('all-messages-seen')

    for (let i = 0; i < this.unseenMessages.length; i++) {
      const message = this.unseenMessages[i]

      this.$APICall(
        'put',
        'MESSAGES',
        '/' + message.id + '/mark-as-seen',
        [],
        () => {
          message.seen = true
        },
        true,
        error => {
          handle_session_error(error, this.$store, this.$router, this.$prompt)
        }
      )
    }

    let pusherChannel_messages = this.$store.state.pusherInstance.subscribe(
      `private-encrypted-event_${this.event.id}_messages`
    )

    pusherChannel_messages.bind('new', message_id => {
      this.$APICall(
        'get',
        'MESSAGES',
        '/' + message_id,
        [],
        data => {
          this.event.messages.push(new Message(data.data))

          this.$emit('new-message')
        },
        true,
        error => {
          handle_session_error(error, this.$store, this.$router, this.$prompt)
        }
      )
    })

    pusherChannel_messages.bind('delete', message_id => {
      getIndexById(message_id, this.event.messages, index => {
        this.event.messages.splice(index, 1)
      })
    })
  },

  methods: {
    handleMessageToArchive(message) {
      this.$APICall(
        'put',
        'MESSAGES',
        '/' + message.id + '/to-archive',
        [],
        data => {
          getIndexById(message.id, this.event.messages, index => {
            this.event.messages.splice(index, 1, new Message(data.data))
          })
        },
        true,
        error => {
          handle_session_error(error, this.$store, this.$router, this.$prompt)
        }
      )
    },

    handleMessageFromArchive(message) {
      this.$APICall(
        'put',
        'MESSAGES',
        '/' + message.id + '/from-archive',
        [],
        data => {
          getIndexById(message.id, this.event.messages, index => {
            this.event.messages.splice(index, 1, new Message(data.data))
          })
        },
        true,
        error => {
          handle_session_error(error, this.$store, this.$router, this.$prompt)
        }
      )
    },

    handleMessageDelete(message) {
      this.$APICall(
        'delete',
        'MESSAGES',
        '/' + message.id,
        [],
        () => {},
        true,
        error => {
          handle_session_error(error, this.$store, this.$router, this.$prompt)
        }
      )

      getIndexById(message.id, this.event.messages, index => {
        this.event.messages.splice(index, 1)
      })
    },
  },
}
</script>
